import { render, staticRenderFns } from "./VoteStatusDialog.vue?vue&type=template&id=6c4e3ab6"
import script from "./VoteStatusDialog.vue?vue&type=script&lang=js"
export * from "./VoteStatusDialog.vue?vue&type=script&lang=js"
import style0 from "./VoteStatusDialog.vue?vue&type=style&index=0&id=6c4e3ab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports